export { default } from './TrendTopicForm';
